<template>
    <!--分享赚钱-->
    <!--导航栏-->
    <ZhaiHead></ZhaiHead>
    <!--导航栏-->
    <!--主体-->
    <div class="container-fluid zhu px-0">
        <div class="row shengse">
            <div class="dixian px-4 py-2 d-flex justify-content-between">
                <div class="lf">
                    <i class="bi bi-coin"></i>
                    分享赚钱
                </div>
            </div>
            <div class="p-3 gohome">
                <h1>御凤楼7年老平台，提现秒到账，另支持多种结算方式,</h1>
                <h1>推广链接以及二维码均做过特殊防封处理，长期有效，无需担心屏蔽问题！</h1>
                <h1>随手一发~就能轻松赚钱！</h1>
                <h1 style="margin-bottom: 1rem !important;">
                    本站为VIP用户提供了 <a href="/EarnbySharing">推广中心</a> 功能，
                </h1>
                <p>
                    完全免费（不花钱就能成为代理）
                </p>
                <p>
                    不需要经验（所有的推广素材由本平台提供）
                </p>
                <p>
                    账务公开透明（可以在推广中心随时查看佣金）
                </p>

                <p>
                    结算方式多样化（支持微信/支付宝/银行卡/USDT）
                </p>
                <h1>佣金收益介绍</h1>

                <!-- 这里开始修改颜色 -->
                <p class="commission-text">
                    有任意用户通过您的二维码或推广链接在本平台开通任意会员您会获得50%的佣金收益。
                </p>
                <p class="commission-text">用户开通月会员，您将获得50元的佣金收益</p>
                <p class="commission-text">用户开通季度会员，您将获得100元的佣金收益</p>
                <p class="commission-text">用户开通年会员，您将获得180元的佣金收益</p>
                <p class="commission-text">用户开通永久至尊VIP 您将获得250元的佣金收益</p>
                <p class="commission-text">
                    佣金可以直接提现（24小时内到账）
                </p>
                <p>
                    下面是某代理3天的佣金收益
                </p>
                <p>
                    只需动动手分享自己的链接 月入十万不是梦！
                </p>
                <!-- 新增：示例收益截图 -->
                <div class="promo-shot">
                    <img class="promo-shot__img" src="@/assets/promo_income.png" alt="佣金收益示例">
                </div>
                <p style="margin-top: 9px !important;">
                    可以在QQ群匿名发布自己的推广海报，也可以在微信群，微博等地方发您的推广链接或者推广二维码。
                    其他的可以发挥自己的想象力去推广
                </p>
                <div class="promo-shot">
                    <img class="promo-shot__img" src="@/assets/promo_income2.jpg" alt="佣金收益示例">
                </div>
                <p  class="commission-text2">
                    成为御凤楼代理流程：
                </p>
                <p  class="commission-text3">
                    注册账号后访问个人中心→我的推广→自动生成专属推广链接→有用户通过你的专属链接或者二维码开通会员即可获得50%的佣金！
                </p>
                <p  class="commission-text4">
                    另招募实力网推 地推 cpa cps seo团队，可以联系客服，提供专属短网址，以及推广扶持，
                    让您推广更便捷！有意者请发邮件至客服邮箱：
                </p>
                <p>
                    yufenglou321@gmail.com
                </p>
                <div class="promo-shot">
                    <img class="promo-shot__img" src="@/assets/promo_income3.png" alt="佣金收益示例">
                </div>

            </div>

        </div>
    </div>
    <!--主体-->
    <!--公共底部-->
    <ZhaiFoot></ZhaiFoot>
    <!--公共底部-->

</template>

<script>
    import ZhaiHead from "../components/ZhaiHead";
    import ZhaiFoot from "../components/ZhaiFoot";

    export default {
        name: "MEarnbySharing",
        components:{ ZhaiHead, ZhaiFoot}
    }
</script>

<style scoped>
    /*顶部占据空间*/
    .gongxi{
        height: 90px;
    }
    /*文本的样式*/
    .gohome h1 {
        font-size: 1rem;
        margin-top: 1rem;
        color: #00c26f;
        padding-left: 15px;
        padding-right: 15px;
    }
    .gohome p {
        font-size: 0.9rem;
        color: #000;
        padding-left: 15px;
        padding-right: 15px;
    }

    /* 新增佣金文字颜色 */
    .commission-text {
        color: #ff6d5f !important;
    }
    /* 新增佣金文字颜色 */
    .commission-text2 {
        color: #ff6d5f !important;
        font-weight: bold;
        margin-top: 8px!important;
        margin-bottom: 0 !important;
    }
    .commission-text3 {
        color: #ff6d5f !important;
        font-weight: bold;
        margin-top: 0px!important;
        margin-bottom: 0 !important;
    }

    .commission-text4 {
        font-weight: bold;
        margin-top: 20px!important;
        margin-bottom: 0 !important;
        font-weight: bold;
    }


    .zhu{
        margin-top: 80px;
    }
    /* 新增：图片容器（做成类似示例图的“卡片”截图效果） */
    .promo-shot{
        margin: 14px 15px 0;          /* 和上方文字留点距离，左右对齐你现有的 15px */
        display: flex;
        justify-content: center;
    }

    .promo-shot__img{
        width: 100%;
        max-width: 360px;             /* 控制成手机截图那种宽度感，可按需要改 340~390 */
        border-radius: 2px;          /* 圆角 */
        box-shadow: 0 6px 18px rgba(0,0,0,.12); /* 轻微阴影 */
        border: 1px solid rgba(0,0,0,.06);      /* 淡淡的边框更像截图卡片 */
        display: block;
    }


</style>
